import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import { DbAgentGroupCreate } from '../db/agentgroups';
import { DatacastContext } from '../context/datacastcloud';

import uuid from 'react-uuid';
import { Checkbox } from 'primereact/checkbox';

const CreateAgentGroup = () => {
 
    const [group, setGroup] = useState({
        name:"",
        uuid:uuid(),
        createAgent:0,
        createStream:0,
        createSource:0,
        destroyAgent:0,
        destroyStream:0,
        destroySource:0,
        editAgent:0,
        editStream:0,
        editSource:0
    })

    const [dirty, setDirty] = useState(false);

    const [ datacastProperties ] = useContext(DatacastContext);
    const navigate = useNavigate();

    

    const createGroup = () => {
        if(dirty) {
            DbAgentGroupCreate(datacastProperties.userIp, group).then((result) => {
                
                if(result.error === 0) {
                    navigate('/admin');
                }

            }).catch((error) => {
                console.error(error);
            });
        }

    }

    const userInput = (field, value) => {

        setGroup({...group, [field]:value.substring(0,36)})
        setDirty(true);
    }

    const permissionChange = (e, field) => {
        setGroup({...group, [field]:e.checked?1:0});
    }

    return (
        <>
            <div className='flex align-content-center' style={{backgroundColor:"rgb(64,64,64)"}}>
                <div className='p-3 text-white font-bold'>CREATE AGENT GROUP</div>
            </div>
            <div className='border-solid surface-border border-1'>
                <div className='p-6'>
                    
                    <div className='grid col-12'>
                        <div className='col-12 md:col-6'>
                            <div className='font-bold mb-1'>Name</div>
                            <div className='flex w-full'>
                                <InputText className='surface-100 w-full border-round-md border-none' keyfilter="alphanum" value={group.name} onChange={(e) => userInput('name',e.target.value)} placeholder="Oshawa"/>
                            </div>
                        </div>
                        <div className='col-12 md:col-6'>
                            <div className='font-bold mb-1'>UNIQUE IDENTIFIER</div>
                            <div className='flex '>
                                <InputText className='surface-100 w-full border-round-md border-none' value={group.uuid}  disabled/>
                            </div>
                        </div>
                        <div className='flex col-12  align-content-center' style={{backgroundColor:"rgb(64,64,64)"}}>
                            <div className='text-white font-bold'>PERMISSIONS</div>
                        </div>
                        <div className='flex-column col-12 md:col-4 align-items-end'>
                            <div className='font-bold mb-1'>AGENT</div>
                            <div className='flex p-2'>
                                <div>
                                    <Checkbox className='surface-100 border-round-md border-none' value={group.createAgent} checked={group.createAgent === 1} onChange={(e)=>permissionChange(e,'createAgent')} />
                                </div>
                                <div className='ml-2'>Create</div>
                            </div>
                            <div className='flex p-2'>
                                <div>
                                    <Checkbox className='surface-100 border-round-md border-none' value={group.destroyAgent} checked={group.destroyAgent === 1} onChange={(e)=>permissionChange(e, 'destroyAgent')}  />
                                </div>
                                <div className='ml-2'>Delete</div>
                            </div>
                            <div className='flex p-2'>
                                <div>
                                    <Checkbox className='surface-100 border-round-md border-none' value={group.editAgent} checked={group.editAgent === 1} onChange={(e)=>permissionChange(e, 'editAgent')}  />
                                </div>
                                <div className='ml-2'>Edit</div>
                            </div>
                        </div>
                        <div className='flex-column col-12 md:col-4 align-items-end'>
                            <div className='font-bold mb-1'>SOURCES</div>
                            <div className='flex p-2'>
                                <div>
                                    <Checkbox className='surface-100 border-round-md border-none' value={group.createSource} checked={group.createSource === 1} onChange={(e)=>permissionChange(e,'createSource')} />
                                </div>
                                <div className='ml-2'>Create</div>
                            </div>
                            <div className='flex p-2'>
                                <div>
                                    <Checkbox className='surface-100 border-round-md border-none' value={group.destroySource} checked={group.destroySource === 1} onChange={(e)=>permissionChange(e, 'destroySource')}  />
                                </div>
                                <div className='ml-2'>Delete</div>
                            </div>
                            <div className='flex p-2'>
                                <div>
                                    <Checkbox className='surface-100 border-round-md border-none' value={group.editSource} checked={group.editSource === 1} onChange={(e)=>permissionChange(e, 'editSource')}  />
                                </div>
                                <div className='ml-2'>Edit</div>
                            </div>
                        </div>
                        <div className='flex-column col-12 md:col-4 align-items-end'>
                            <div className='font-bold mb-1'>DESTINATIONS</div>
                            <div className='flex p-2'>
                                <div>
                                    <Checkbox className='surface-100 border-round-md border-none' value={group.createStream} checked={group.createStream === 1} onChange={(e)=>permissionChange(e,'createStream')} />
                                </div>
                                <div className='ml-2'>Create</div>
                            </div>
                            <div className='flex p-2'>
                                <div>
                                    <Checkbox className='surface-100 border-round-md border-none' value={group.destroyStream} checked={group.destroyStream === 1} onChange={(e)=>permissionChange(e, 'destroyStream')}  />
                                </div>
                                <div className='ml-2'>Delete</div>
                            </div>
                            <div className='flex p-2'>
                                <div>
                                    <Checkbox className='surface-100 border-round-md border-none' value={group.editStream} checked={group.editStream === 1} onChange={(e)=>permissionChange(e, 'editStream')}  />
                                </div>
                                <div className='ml-2'>Edit</div>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='flex justify-content-end mt-4' >
                                <Link to="/admin" style={{ textDecoration: 'none' }} >
                                    <Button label="Cancel" className="p-button-danger" icon="pi pi-times" />
                                </Link>
                                <div className='pl-2'>
                                    <Button label="Create" className="p-button-primary" icon="pi pi-check" onClick={createGroup} disabled={!dirty}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>            
    
    )
}

export default CreateAgentGroup;